import { get } from "lodash";
import log from "loglevel";
import * as t from "types";

export const getJwtReducerResponse = (
  state: any,
  responseType: string
): t.JWT => {
  log.info("Getting JWT from Store...");
  const value = get(state, `jwt.response.${responseType}`);
  return value;
};
